export default __webpack_public_path__ + "static/media/DreamJobs1_04.2ba097b5.png";